import { Form, Input, Select } from 'antd';
import { MasterFormField } from 'features/master/components/master-filter-form';
import { FormSectionsSeparator } from 'features/users/components/modals/form-sections-separator';

export const StaionsFormItems = ({ data }: any) => {


  return (
    <FormSectionsSeparator title={""}>
      <Form.Item<MasterFormField>
        label={'Station Name'}
        name={MasterFormField.Title}
        rules={[
          {
            required: true,
            whitespace: true,
          },
        ]}
      >
        <Input
          placeholder={'Enter a title'}
        />
      </Form.Item>
      <Form.Item<MasterFormField>
        label={'Type'}
        name={MasterFormField.type}
         rules={[
          {
            required: true
            
          },
        ]}
      >
        <Select
          placeholder="Select Type"
          options={data?.rc?.map((item: any) => ({
            label: item.title, // Text displayed to the user
            value: item.id,   // The value saved in the form
          }))}
        />
      </Form.Item>
    </FormSectionsSeparator>
  );
};
